export const moduleId = 'goods-process';


export const state = {

    isShow: true
}

export const mutations = {
    setIsShow(state, flag) {
        state.isShow = flag
    }
}

export const actions = {}


// WEBPACK FOOTER //
// ./src/store/modules/cost-accounting/goods-process/index.js